// require('dotenv').config()
export const REACT_APP_API = process.env.REACT_APP_API //endpoint
//buscar clientes para mandar mensajes segun incidencia o promociones
export const REACT_APP_API_CI = process.env.REACT_APP_API_CI //obtener clientes inactivos
export const REACT_APP_API_CA = process.env.REACT_APP_API_CA //obtener clientes activos
export const REACT_APP_API_AC = process.env.REACT_APP_API_AC //obtener todos los clientes
//api para enviar los mensajes
export const REACT_APP_API_SENDER = process.env.REACT_APP_API_SENDER //api para enviar whatsapp
export const REACT_APP_API_PASSWORD = process.env.REACT_APP_API_PASSWORD //password para enviar mensajes
export const  REACT_APP_API_CUENTA = process.env.REACT_APP_API_CUENTA //api para buscar cuenta por numero de whatsapp
export const REACT_APP_API_STREAM = process.env.REACT_APP_API_STREAM // api para stream de video
export const REACT_APP_API_WAPP = process.env.REACT_APP_API_WAPP // url de whatsapp

export const REACT_APP_SMSKEY = process.env.REACT_APP_SMSKEY // keysms
export const REACT_APP_CLOUPRESET=process.env.REACT_APP_CLOUPRESET // keysms
export const REACT_APP_CLOUUSER=process.env.REACT_APP_CLOUUSER // keysms
export const REACT_APP_GEO=process.env.REACT_APP_GEO // keysms
export const REACT_APP_API_HOOK=process.env.REACT_APP_API_HOOK // para hook avisamail
export const REACT_APP_API_WA=process.env.REACT_APP_API_WA // url de whatsapp
export const REACT_APP_DEV_TOOLS=process.env.REACT_APP_DEV_TOOLS // url de whatsapp
export const REACT_APP_CLOUDINARY_NAME=process.env.REACT_APP_CLOUDINARY_NAME // url de cloudinary name

//productos
export const productsEndpoint= REACT_APP_API + 'products/';
export const productByIdEndpoint = productsEndpoint + ':id';
export const productByCatEndpoint = productsEndpoint + 'bycat/:category';
export const addProductEndpoint = productsEndpoint + 'add';
export const stockProductEndpoint = productsEndpoint + 'stock'
export const modifyProductEndpoint = productsEndpoint + 'update';

// categories

export const categoriesEndpoint= REACT_APP_API + 'categories/';

// brands

export const brandsEndpoint= REACT_APP_API + 'brands/';

//carrito

export const productId = REACT_APP_API + 'product/'

// configs y users

export const usersEndpoint= REACT_APP_API + 'users/';

export const configByIdEndpoint = REACT_APP_API + 'configs/';

// webpush

export const webpushEndpoint= REACT_APP_API + 'push/';
export const suscribeEndpoint= REACT_APP_API + 'push/subscription';

// recaptchaGoogle

export const REACT_APP_CLAVESITIO = process.env.REACT_APP_CLAVESITIO
export const REACT_APP_CLAVESECRETA = process.env.REACT_APP_CLAVESECRETA
